import axios from "axios";

const baseURL = "https://norskfolkehjelp-oljefond-funcs.azurewebsites.net/api/";

const instance = axios.create({ baseURL: baseURL });

const get = (endpoint) => {
  return instance.get(endpoint);
};

const post = (endpoint, postData) => {
  return instance.post(endpoint, postData);
};

export const getCareCounter = async () => {
  const response = await get("GetCareCounter");
  return response.data;
};

export const incrementCareCounter = async () => {
  await post("IncrementCareCounter");
  return true;
};

export const sendEmail = async (name, email, english, recaptchaCode) => {
  return await post("SendEmail", {
    Name: name,
    Email: email,
    English: english,
    "g-recaptcha-response": recaptchaCode,
  });
};
